import { Container, Graphics, IDestroyOptions, Sprite, Ticker } from "pixi.js";
import { nameof } from "../../../../../../../shared/bindable-data";
import { ICanvasScaler } from "../../../../../../../canvas/ICanvasScaler";
import { MarketplaceNewsLine } from "./MarketplaceNewsLine";
import { IMarketplaceNewsModel } from "../../models/news/IMarketplaceNewsModel";
import { MarketplaceNewsItem } from "../../models/news/MarketplaceNewsItem";
import { MarketplaceResourcePackage } from "../../../resources/MarketplaceResourcePackage";

export class MarketplaceNewsPresenter extends Container {
    private readonly mpNewsModel: IMarketplaceNewsModel;
    private readonly canvasScaler: ICanvasScaler;
    private readonly newsBackground: Sprite;
    private readonly newsLineContainer: Container;
    private readonly newsLine: MarketplaceNewsLine;
    private newsMask: Graphics;
    private animate: boolean;

    public constructor(
        marketplaceResourcesPackage: MarketplaceResourcePackage,
        mpNewsModel: IMarketplaceNewsModel,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.canvasScaler = canvasScaler;
        this.newsBackground = new Sprite(marketplaceResourcesPackage.assets_views_marketplace_news_background_png);
        this.addChild(this.newsBackground);
        this.newsMask = new Graphics().beginFill(0xffffff).drawRect(10, 10, this.newsBackground.width - 20, this.newsBackground.height - 20).endFill();
        this.newsLineContainer = new Container();
        this.newsLineContainer.mask = this.newsMask;
        this.newsBackground.addChild(this.newsLineContainer);
        this.newsBackground.addChild(this.newsMask);
        this.newsLine = new MarketplaceNewsLine();
        this.newsLineContainer.addChild(this.newsLine);
        this.animate = false;
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
        this.mpNewsModel = mpNewsModel;
        this.mpNewsModel.propertyChanged.add(this.onMarketplaceNewsModelChanged, this);
        this.onMarketplaceNewsModelChanged(this.mpNewsModel, nameof(this.mpNewsModel, "news"))
        Ticker.shared.add(this.moveLine, this);
        if (this.mpNewsModel.news.value?.length > 0) {
            this.updateNewsLine(this.mpNewsModel.news.value);
        }
    }

    private moveLine(dt: number): void {
        if (!this.animate) {
            return;
        }
        this.newsLine.position.x -= dt;
    }

    private onMarketplaceNewsModelChanged(model: IMarketplaceNewsModel, property: string): void {
        switch (property) {
            case nameof(model, "news"):
                if (model.news.value?.length > 0) {
                    this.updateNewsLine(model.news.value);
                }
                break;
        }
    }

    private updateNewsLine(news: Array<MarketplaceNewsItem>): void {
        this.animate = news.length >= 0;
        this.newsLine.setData(news);
    }

    private layout(width: number, _height: number): void {
        this.newsBackground.width = width;
        this.newsLineContainer.position.set(0, (this.newsBackground.height - this.newsLineContainer.height) * 0.5);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.mpNewsModel.propertyChanged.remove(this.onMarketplaceNewsModelChanged, this);
        Ticker.shared.remove(this.moveLine, this);
        super.destroy(options);
    }
}
